import { Form, Input, Modal } from "antd";
import { useState } from "react";
import * as APIS from "../../utils/helper/enum";
import * as Validation from "../../utils/helper/validation";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";

const ChangePassword = ({ isOpen, onCancel }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [apiError, setApiError] = useState({});



  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
    setApiError((prevError) => ({
      ...prevError,
      [name]: undefined,
    }));
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.ONBOARDING_APIS?.CHANGE_PASSWORD, "put", values, {}, true
      );
      let apiResponse = response?.data;
      if (apiResponse?.status === "SUCCESS") {
        let msg = "Password changed successfully, please login again.";
        toast.success(msg, {
          duration: 2000,
        });
        onCancel();
      } else {
        toast.error(apiResponse.message, {
          duration: 2000,
        });
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Modal
        title="Change Password"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={() => form.submit()}
        okText="Change Password"
        cancelText="Cancel"
        width={500}
      >
        <Form
          form={form}
          name="changePassword"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            label="Current Password"
            name="old_password" 
            rules={[
              {
                required: true,
                message: "Please enter your current password",
              },
            ]}
          >
            <Input.Password size="large" placeholder="Enter current password" />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="new_password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
            help={apiError && apiError.password}
            validateStatus={apiError && apiError.password ? "error" : ""}
            validateTrigger={"onSubmit"}
          >
            <Input.Password size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("new_password", value);
                handleInputChange("new_password");
              }}
              placeholder="Please Enter Your Password"
            />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirm_password"
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "New Password and confirm password does not match."
                    )
                  );
                },
              }),
            ]}
              help={apiError && apiError.confirm_password}
              validateStatus={
                apiError && apiError.confirm_password ? "error" : ""
              }
              validateTrigger={"onSubmit"}
          >
            <Input.Password size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("confirm_password", value);
                handleInputChange("confirm_password");
              }}
              placeholder="Please Enter Your Confirm Password"
          />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default ChangePassword;
